export default {
  lang: {
    selectAll: "Selecteer alle pagina's",
    selected: 'Geselecteerd',
    term: 'Artikel',
    deselect: 'Deselecteer',
  },
};
